import React, { useState } from "react";
import SEO from "../../components/SEO";
import Layout from "../../components/Layout";
import Container from "../../components/Container";
import { Desktop, Tablet } from "../../constants/responsive";
import { css } from "@emotion/core";
import {
  FormattedHTMLMessage,
  useIntl,
  FormattedMessage,
} from "gatsby-plugin-intl";
import GeneralBanner from "../../components/GeneralBanner";
import {
  AnnualAdvisoryFees2,
  StockTradingFees,
  ActivePortfoliosAnnualFee,
  FeeDetailCards,
} from "../../components/FeeAnnualAdvisoryFees";

import { Link } from "gatsby";
import {
  Category,
  HKRow,
  USRow,
  NorthboundRow,
  Tab,
} from "../../components/FeePageComponents";
import Blank from "../../components/Blank";

const FeePage = () => {
  const intl = useIntl();
  const [selected, setSelected] = useState("hk");
  const [feeSelected, setFeeSelected] = useState("AdvisedPortfolios");
  const intlMap = {
    AdvisedPortfolios: "advised-portfolios",
    StockTrading: "stock-trading",
  };
  return (
    <Layout footerBlank>
      <SEO
        title={intl.formatMessage({ id: "fee.title" })}
        description={intl.formatMessage({ id: "fee.description" })}
        keywords={intl.formatMessage({ id: "fee.keywords" })}
      />
      <GeneralBanner>
        <FormattedHTMLMessage id="fee.title" />
      </GeneralBanner>
      <Container
        css={css`
          margin-top: 48px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          ${Tablet} {
            margin-top: 94px;
            align-items: center;
          }
          ${Desktop} {
            margin-top: 130px;
            align-items: center;
          }
        `}
      >
        {/* 个股与投资组合的【切换按钮】 */}
        <div
          css={css`
            display: flex;
            box-shadow: 0 0 10px 0 rgba(101, 101, 101, 0.16);
            border-radius: 6px;
            align-self: center;
            margin-bottom: 50px;
            ${Tablet} {
              margin-bottom: 75px;
            }
            ${Desktop} {
              margin-bottom: 79px;
            }
          `}
        >
          <Tab
            selected={feeSelected === "AdvisedPortfolios"}
            onClick={() => {
              setFeeSelected("AdvisedPortfolios");
            }}
          >
            {intl.formatMessage({ id: "fee.above-tags.advised-portfolios" })}
          </Tab>
          <Tab
            selected={feeSelected === "StockTrading"}
            onClick={() => {
              setFeeSelected("StockTrading");
            }}
          >
            {intl.formatMessage({ id: "fee.above-tags.stock-trading" })}
          </Tab>
        </div>

        {/* 【年化咨询费】 */}
        <div
          css={css`
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 100%;
            margin-bottom: 40px;
            ${Tablet} {
              text-align: center;
              margin-bottom: 30px;
            }
            ${Desktop} {
              width: 100%;
              margin-bottom: 54px;
            }
          `}
        >
          <section
            css={css`
              width: 100%;
              margin-bottom: 40px;
              ${Tablet} {
                text-align: center;
                margin-bottom: 30px;
              }
              ${Desktop} {
                width: 100%;
                margin-bottom: 54px;
              }
            `}
          >
            <h1
              css={css`
                font-weight: bold;
                align-self: flex-start;
                font-size: 16px;
                line-height: 1.25;
                margin-bottom: 13px;
                text-align: ${feeSelected === "AdvisedPortfolios"
                  ? "left"
                  : "center"};
                width: 100%;
                ${Tablet} {
                  align-self: center;
                  font-size: 20px;
                  line-height: 1;
                  margin-bottom: 16px;
                }
                ${Desktop} {
                  font-size: 30px;
                  line-height: 0.83;
                  margin-bottom: 16px;
                }
              `}
            >
              <FormattedHTMLMessage
                id={`fee.${intlMap[feeSelected]}.annual.title`}
              />
              <br />
              {feeSelected === "AdvisedPortfolios" && (
                <span
                  css={css`
                    font-weight: normal;
                    font-size: 12px;
                    color: #69758a;
                    ${Tablet} {
                      font-size: 12px;
                    }
                    ${Desktop} {
                      font-size: 16px;
                    }
                  `}
                >
                  <FormattedMessage id={`fee.annual.subtitle`} />
                </span>
              )}
            </h1>
            {/* 【股票组合收费】 */}
            <AnnualAdvisoryFees2 show={feeSelected === "AdvisedPortfolios"} />
            {/* 【个股收费】 */}
            <StockTradingFees show={feeSelected === "StockTrading"} />
            {feeSelected === "StockTrading" && (
              <span
                css={css`
                  font-size: 8px;
                  font-weight: normal;
                  line-height: 1.25;
                  ${Tablet} {
                    font-size: 8px;
                    line-height: 1.88;
                  }
                  ${Desktop} {
                    font-size: 10px;
                    line-height: 1.5;
                  }
                `}
              >
                <FormattedHTMLMessage
                  id={`fee.${intlMap[feeSelected]}.annual.bottom-note`}
                />
              </span>
            )}
          </section>
          {/* SGU收费 */}
          <section
            css={css`
              width: 100%;
              text-align: left;
              display: ${feeSelected === "AdvisedPortfolios"
                ? "block"
                : "none"};
            `}
          >
            <h1
              css={css`
                font-weight: bold;
                align-self: flex-start;
                font-size: 16px;
                line-height: 1.25;
                margin-bottom: 13px;
                text-align: left;
                ${Tablet} {
                  align-self: center;
                  font-size: 20px;
                  line-height: 1;
                  margin-bottom: 16px;
                }
                ${Desktop} {
                  font-size: 30px;
                  line-height: 0.83;
                  margin-bottom: 16px;
                }
              `}
            >
              <FormattedHTMLMessage
                id={`fee.active-portfolios-annual-fee.title`}
              />
              <br />
              <span
                css={css`
                  font-weight: normal;
                  font-size: 12px;
                  color: #69758a;
                  ${Tablet} {
                    font-size: 12px;
                  }
                  ${Desktop} {
                    font-size: 16px;
                  }
                `}
              >
                <FormattedMessage
                  id={`fee.active-portfolios-annual-fee.subtitle`}
                />
              </span>
            </h1>
            <ActivePortfoliosAnnualFee
              show={feeSelected === "AdvisedPortfolios"}
            />
          </section>
        </div>
        {/* 【交易佣金收费明细】 */}
        {feeSelected === "AdvisedPortfolios" && (
          <div
            css={css`
              display: flex;
              align-items: center;
              flex-direction: column;
              width: 100%;
              margin-bottom: 40px;
              ${Tablet} {
                text-align: center;
                margin-bottom: 30px;
              }
              ${Desktop} {
                width: 100%;
                margin-bottom: 54px;
              }
            `}
          >
            <h1
              css={css`
                font-weight: bold;
                align-self: flex-start;
                font-size: 16px;
                line-height: 1.25;
                margin-bottom: 13px;
                text-align: left;
                width: 100%;
                ${Tablet} {
                  align-self: center;
                  font-size: 20px;
                  line-height: 1;
                  margin-bottom: 16px;
                }
                ${Desktop} {
                  font-size: 30px;
                  line-height: 0.83;
                  margin-bottom: 16px;
                }
              `}
            >
              <FormattedHTMLMessage
                id={`fee.trade-commission-fee-details.title`}
              />
              <br />
              <span
                css={css`
                  font-weight: normal;
                  font-size: 12px;
                  color: #69758a;
                  ${Tablet} {
                    font-size: 12px;
                  }
                  ${Desktop} {
                    font-size: 16px;
                  }
                `}
              >
                <FormattedMessage id={`fee.annual.commission fee subtitle`} />
              </span>
            </h1>
            <FeeDetailCards />
          </div>
        )}
        {/* 【如何计算收费】 */}
        <div
          css={css`
            text-align: center;
            align-self: center;
            font-weight: normal;
            font-size: 12px;
            line-height: 1.25;
            margin-bottom: 40px;
            ${Tablet} {
              font-size: 12px;
              line-height: 1.25;
              margin-bottom: 60px;
            }
            ${Desktop} {
              font-size: 20px;
              line-height: 1.25;
              margin-bottom: 100px;
            }
          `}
        >
          <span
            css={css`
              font-weight: bold;
            `}
          >
            <FormattedHTMLMessage id={`fee.fee-calculations`} />
          </span>
          <br />
          {/* 点击跳转去FAQ页面的指定tag */}
          <div
            onClick={() => {
              sessionStorage["faq-selected-tag"] = 6;
              sessionStorage["faq-selected-faq"] = 44;
            }}
          >
            <Link
              to={`/${intl.locale}/learn/faq`}
              style={{ color: "#ee2f79" }}
            >
              {intl.formatMessage({
                id: `fee.FAQ`,
              })}
            </Link>
          </div>
        </div>
        {/* 【其他服務及第三方收費】 */}
        <span
          css={css`
            font-weight: bold;
            font-size: 16px;
            line-height: 1.25;
            margin-bottom: 14px;
            ${Tablet} {
              font-size: 20px;
              line-height: 1;
              margin-bottom: 16px;
            }
            ${Desktop} {
              font-size: 30px;
              line-height: 0.67;
              margin-bottom: 14px;
            }
          `}
        >
          <FormattedHTMLMessage id={`fee.fees-title`} />
        </span>
        <span
          css={css`
            font-weight: normal;
            font-size: 12px;
            line-height: 1.08;
            margin-bottom: 13.5px;
            ${Tablet} {
              text-align: center;
              width: 577px;
              font-size: 12px;
              line-height: 1.08;
              margin-bottom: 19.5px;
            }
            ${Desktop} {
              width: 1023px;
              font-size: 20px;
              line-height: 1.25;
              margin-bottom: 30px;
            }
          `}
        >
          <FormattedHTMLMessage
            id={`fee.${intlMap[feeSelected]}.fees-description`}
          />
        </span>
        {/* 【三股切换按钮】- PC与IPAD端 */}
        <div
          css={css`
            display: none;
            z-index: 5;
            box-shadow: 0 0 10px 0 rgba(101, 101, 101, 0.16);
            border-radius: 6px;
            ${Tablet} {
              display: flex;
              justify-content: center;
            }
            ${Desktop} {
              width: fit-content;
            }
          `}
        >
          <Tab
            selected={selected === "hk"}
            onClick={() => {
              setSelected("hk");
            }}
          >
            <FormattedMessage id="fee.hk" />
          </Tab>
          <Tab
            selected={selected === "us"}
            onClick={() => {
              setSelected("us");
            }}
          >
            <FormattedMessage id="fee.us" />
          </Tab>
          <Tab
            selected={selected === "northbound"}
            onClick={() => {
              setSelected("northbound");
            }}
          >
            <FormattedMessage id="fee.northbound" />
          </Tab>
        </div>
        {/* 【三股切换按钮】- 手机端 */}
        <div
          css={css`
            display: block;
            ${Tablet} {
              display: none;
            }
          `}
        >
          <div
            css={css`
              display: flex;
              z-index: 5;
              box-shadow: 0 0 10px 0 rgba(101, 101, 101, 0.16);
              border-radius: 6px;
            `}
          >
            <Tab
              selected={selected === "hk"}
              onClick={() => {
                setSelected("hk");
              }}
            >
              <FormattedMessage id="fee.hk" />
            </Tab>
            <Tab
              selected={selected === "us"}
              onClick={() => {
                setSelected("us");
              }}
            >
              <FormattedMessage id="fee.us" />
            </Tab>
          </div>
          <div
            css={css`
              z-index: 5;
              box-shadow: 0 0 10px 0 rgba(101, 101, 101, 0.16);
              border-radius: 6px;
              width: fit-content;
              margin-top: 10.9px;
            `}
          >
            <Tab
              selected={selected === "northbound"}
              onClick={() => {
                setSelected("northbound");
              }}
            >
              <FormattedMessage id="fee.northbound" />
            </Tab>
          </div>
        </div>
      </Container>
      {/* 【收费详情】 */}
      <Container
        css={css`
          margin-top: 0.5px;
          width: 100%;
          ${Tablet} {
            margin-top: -21.7px;
            width: 580px;
          }
          ${Desktop} {
            margin-top: 6.4px;
            padding: 0;
            width: 672px;
          }
        `}
      >
        {/* 港股收费 */}
        <div
          css={css`
            display: ${selected === "hk" ? "block" : "none"};
          `}
        >
          <Category id="securities" country="hk" />
          <section className="hk-securities">
            {feeSelected === "StockTrading" && (
              <HKRow type="stock-commission" />
            )}
            {feeSelected === "StockTrading" && <HKRow type="stock-platform" />}
            <HKRow
              type="ccass-settlement"
              boldBorder={feeSelected !== "StockTrading"}
            />
            {feeSelected === "StockTrading" && (
              <HKRow type="financial-transaction-tax" boldBorder />
            )}
          </section>
          <Category id="regulatory" country="hk" />
          <section className="hk-regulatory">
            <HKRow type="tariff" />
            <HKRow type="stamp" />
            <HKRow type="hkex" />
            <HKRow type="sfc" />
            <HKRow type="frc-tl" />
            <HKRow type="scrip-fee" />
            <HKRow type="bscf" />
            <HKRow type="dealing-with" boldBorder />
          </section>
          <Category id="fund" country="hk" />
          <section className="hk-fund">
            <HKRow type="transfer-deed" />
            <HKRow type="transfer-hk" boldBorder />
          </section>

          <Category id="other" country="hk" />
          <section className="hk-other">
            <HKRow type="cash-dividend" boldBorder />
          </section>

          {/* 备注 */}
          {/* <span
            css={css`
              display: inline-block;
              margin-top: 10px;
              font-size: 12px;
              ${Tablet} {
              }
              ${Desktop} {
              }
            `}
          >
            <FormattedHTMLMessage id='fee.hk-types.remarks' />
          </span> */}
        </div>
        {/* 美股收费 */}
        <div
          css={css`
            display: ${selected === "us" ? "block" : "none"};
          `}
        >
          <Category id="securities" country="us" />
          <section className="us-securities">
            {feeSelected === "StockTrading" && (
              <USRow type="stock-commission" />
            )}
            {feeSelected === "StockTrading" && <USRow type="stock-platform" />}
            {feeSelected === "AdvisedPortfolios" && (
              <USRow type="us-third-party" />
            )}

            <USRow
              type="stock-settlement"
              boldBorder={feeSelected !== "StockTrading"}
            />
            {feeSelected === "StockTrading" && (
              <USRow type="financial-transaction-tax" boldBorder />
            )}
          </section>
          <Category id="regulatory" country="us" />
          <section className="us-regulatory">
            <USRow type="transaction" />
            <USRow type="finra" tag="tag-1" />
            <USRow type="ADR" tag="tag-2" />
            <USRow type="dealing-with" tag="tag-2" boldBorder />
          </section>
          <Category id="fund" country="us" />
          <section className="us-fund">
            <USRow type="transfer-us" boldBorder />
          </section>
          <Category id="other" country="us" />
          <section className="us-other">
            <USRow type="cash-dividend" />
            <USRow type="withholding" boldBorder />
          </section>
          {/* 备注 */}
          <span
            css={css`
              display: inline-block;
              margin-top: 10px;
              font-size: 12px;
            `}
          >
            {feeSelected === "AdvisedPortfolios" && (
              <FormattedHTMLMessage id="fee.us-types.remarks" />
            )}
          </span>
        </div>
        {/* A股收费 */}
        <div
          css={css`
            display: ${selected === "northbound" ? "block" : "none"};
          `}
        >
          {feeSelected === "StockTrading" && (
            <>
              <Category id="securities" country="northbound" />
              <section className="northbound-securities">
                <NorthboundRow type="stock-commission" />
                <NorthboundRow type="stock-platform" boldBorder />
              </section>
            </>
          )}
          <Category id="regulatory" country="northbound" />
          <section className="northbound-regulatory">
            <NorthboundRow type="handling" />
            <NorthboundRow type="smf" />
            <NorthboundRow type="stamp" />
            <NorthboundRow type="transfer" />
            <NorthboundRow type="rtf" />
            <NorthboundRow type="portfolio" />
            <NorthboundRow type="dividend" boldBorder />
          </section>
          <Category id="fund" country="cn" />
          <section className="cn-fund">
            <NorthboundRow type="transfer-cn" boldBorder />
          </section>

          <Category id="other" country="northbound" />
          <section className="northbound-other">
            <NorthboundRow type="cash-dividend" boldBorder />
          </section>
        </div>
        <div
          css={css`
            width: 100%;
            text-align: left;
            margin-top: 16px;
            font-size: 14px;
            line-height: 1.25;
            color: #69758a;
          `}
        >
          <FormattedMessage id={`fee.effective-date`} />
        </div>
      </Container>
    </Layout>
  );
};

export default FeePage;
